import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFormValues } from "redux-form";
import { Icon } from "rhombus-react";

import { generateAssets, discardAsset } from "reducers/VersionGeneration";
import { useVariableBounds } from "./utils";
import { AI_GENERATE_VERSIONS_FORM } from "./constants";

import GeneratingPlaceholder from "./GeneratingPlaceholder";
import { useTooltipRebuild } from "hooks/useTooltipRebuild";

const CHAR_OVERFLOW_COUNT = 98;

export default function TextVariableList(props){
	const {
		libraryId,
		variableName,
		variableOptions,
	} = props;

	const [isGenerating, setIsGenerating] = useState(false);
	const dispatch = useDispatch();
	// const generatedAssets = useSelector(state => state.versionGeneration?.generatedAssets);
	const { getTextWithBounds } = useVariableBounds();
	const formValues = useSelector(getFormValues(AI_GENERATE_VERSIONS_FORM))
		;

	const brandKits = formValues["brand-kits"];
	const {
		prompt,
		audiences,
		products,
	} = formValues;

	function regenerate(){
		setIsGenerating(true);
		const data = {
			// ...generatedAssets,
			prompt,
			// Conditionally add metadata to request body
			brandKits: brandKits ? [{ id: brandKits }] : [],
			audiences: audiences ? [{ id: audiences }] : [],
			products: products ? [{ id: products }] : [],
			texts: [
				getTextWithBounds({ name: variableName })
			],
			images: [],
		};
		dispatch(generateAssets(libraryId, data, { patch: true }))
			.finally(() => {
				setIsGenerating(false);
			});
	}

	function discard(variableName, value){
		dispatch(discardAsset("texts", variableName, value));
	}

	let optionList;
	if(variableOptions.length){
		optionList = variableOptions.map((option, index) => {
			const { value } = option || {};
			const dataTip = value.length > CHAR_OVERFLOW_COUNT ? value : "";

			return (
				<div className="text-option" key={value}>
					<div data-tip={dataTip} className="text-content">
						{value}
					</div>
					<Icon
						name="far fa-trash-alt"
						data-tip="Delete"
						className={`cypress-gen-ai-delete-${variableName.toLowerCase()}-${index}`}
						onClick={() => { discard(variableName, value); }}
					/>
				</div>
			);
		});
	} else {
		optionList = (
			<div className="no-assets">
				<Icon name="far fa-mug-hot" />
				No assets available
			</div>
		);
	}

	useTooltipRebuild(optionList);

	const content = isGenerating ? <GeneratingPlaceholder /> : optionList;

	return (
		<>
			<div className="variable-name text-variable-name">
				{variableName}
				<Icon
					name="refresh"
					className={`cypress-gen-ai-${variableName}-refresh`}
					onClick={regenerate}
					data-tip="Regenerate"
				/>
			</div>
			<div className="variable-options">
				{content}
			</div>
		</>
	);
}

TextVariableList.displayName = "TextVariableList";
